export enum TopFansOrder {
  TotalSpend = 'TotalSpend',
  Tips = 'Tips',
  PPVSales = 'PPVSales',
  SubscriptionDays = 'SubscriptionDays',
  Subscription = 'Subscription',
  Posts = 'Posts',
  Messages = 'Messages',
}


export const topFansOrderOptions = [
  {
    value: TopFansOrder.TotalSpend,
    label: 'Rank by total spend',
  },
  {
    value: TopFansOrder.Subscription,
    label: 'Rank by subscription',
  },
  {
    value: TopFansOrder.Posts,
    label: 'Rank by posts',
  },
  {
    value: TopFansOrder.Tips,
    label: 'Rank by tips',
  },
  {
    value: TopFansOrder.Messages,
    label: 'Rank by messages',
  },
  {
    value: TopFansOrder.SubscriptionDays,
    label: 'Rank by subscription days',
  },
]
